<template>
  <EnrollList :path="'/entrain'"></EnrollList>
</template>

<script>
  import EnrollList from '@/page/modules/enroll/list'
  export default {
    components: { EnrollList },
    data () {
      return {
      }
    }
  }
</script>

<style scoped>
  .signup_bg { margin-top: 121px; }
</style>



// WEBPACK FOOTER //
// src/page/entrain/enroll/list.vue